<script setup lang="ts">

const props = withDefaults(defineProps<{
  size?: 'sm' | 'md' | 'lg'
  btn?: 'blue' | 'silver' | 'orange' | 'gold' | 'light-blue' | 'light-gray' | 'yellow-green'
  type?: 'button' | 'link'
  rounded?: boolean
  hoverRaise?: boolean

  colors?: {
    bg: string,
    color: string,
    text: string
    h: {
      bg: string,
      color: string,
      text: string
      a: {
        bg: string,
        color: string,
        text: string
      }
    }
    a: {
      bg: string,
      color: string,
      text: string
      h: {
        bg: string,
        color: string,
        text: string
      }
    }
  }
}>(), {
  size: 'md',
  btn: 'blue',
  type: 'button',
  rounded: true,
  hoverRaise: true
})

</script>


<template>
  <button class="mpd-button" :class="['s-'+size, 'b-'+btn, 'type-'+type, { 'rounded': rounded, 'no-hover-raise': !hoverRaise }]">  
    <slot />
  </button>
</template>


<style lang="scss" scoped>


.mpd-button {

  position: relative;
  background-color: var(--i-blue);
  color: white;

  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.03em;
  transition: all 0.1s ease-in-out;

  &.b-light-gray {
    background-color: var(--e-lighter-gray);
    color: var(--e-light-blue);

    &:hover {
      background-color: var(--e-light-blue);
      color: white;
      &:active {
        background-color: var(--e-orange-gold);
        color: white;
      }
    }
  }

  &.b-blue {
    background-color: var(--i-blue);
    color: white;

    &:hover {
      background-color: var(--i-blue-hover);
      color: white;
      &:active {
        background-color: var(--i-blue-active);
        color: white;
      }
    }
  }
  &.b-yellow-green {
    background-color: var(--i-yellow-green);
    color: white;

    &:hover {
      background-color: var(--i-yellow-green-hover);
      color: white;
      &:active {
        background-color: var(--i-yellow-green-active);
        color: white;
      }
    }
  }

  &.rounded {
    border-radius: 60px;
  }

  &.md {
    font-size: fs(0);
    padding: gr(0.75) gr(1.5);
    
  }

  &.lg {
    font-size: fs(0.5);
  }

  &.sm {
    font-size: fs(0.25);
  }

  &:hover {
    transform: translateY(-1px);

    &:active {
      transform: translateY(0px);
    }
    &.no-hover-raise {
      transform: translateY(0px);;

      &:active {
        transform: translateY(0px);
      }
    }
  }
  
}

</style>